exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-early-evening-dinner-cruise-tsx": () => import("./../../../src/pages/early-evening-dinner-cruise.tsx" /* webpackChunkName: "component---src-pages-early-evening-dinner-cruise-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

